export default function Go_Compiler () {
  return (
    <div>
      <h1>Go_Compiler </h1>
      <p>Go Compiler</p>
    </div>
  );
}